import React from 'react';
import { FIELD_READONLY, fieldInputClass } from '../UI/DisplayField';

const reqBorder = (filled) => filled
  ? ''
  : 'border-rose-300 dark:border-rose-700/60 focus:border-rose-500 focus:ring-rose-500/20';
const isFilled = (v) => String(v ?? '').trim() !== '';
// The shared field look; read-only ones as shown values (DisplayField).
const reqFieldCls = (readOnly, filled) => (readOnly ? `w-full ${FIELD_READONLY}` : fieldInputClass(!filled));

// Shared with the agreement's payout section (ContractPreview).
export const ACCOUNT_TYPES = ['Cheque', 'Savings', 'Transmission'];
export const NAMIBIAN_BANKS = [
  'Bank Windhoek',
  'First National Bank (FNB) Namibia',
  'Standard Bank Namibia',
  'Nedbank Namibia',
  'Letshego Bank Namibia',
  'NamPost',
];
const BankInfoForm = ({
  formData,
  setFormData,
  formErrors,
  hideHeader = false,
  readOnly = false,
  onFieldFocus
}) => {
  const handleFieldFocus = (field) => {
    if (!readOnly && typeof onFieldFocus === 'function') {
      onFieldFocus(field);
    }
  };

  return (
    
    <div className="bg-green-50 dark:bg-slate-800 rounded-lg shadow p-6 text-sm form-compact">
      {!hideHeader && (
        <div className="flex items-center gap-3 mb-6">
          <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-blue-500 to-indigo-600 text-white flex items-center justify-center">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
              <rect width="20" height="12" x="2" y="6" rx="2" />
              <circle cx="12" cy="12" r="3" />
            </svg>
          </div>
          <h3 className="text-sm font-semibold text-gray-900 dark:text-slate-100">Bank Information</h3>
        </div>
      )}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-medium text-gray-800 dark:text-slate-200 mb-1">Bank Name</label>
          {readOnly ? (
            <input
              type="text"
              value={formData.bank_name || ''}
              readOnly
              placeholder="Bank Name"
              className={`w-full ${readOnly ? FIELD_READONLY : ''}`}
              required
            />
          ) : (
            <select
              value={formData.bank_name || ''}
              onFocus={() => handleFieldFocus('bank_name')}
              onChange={e => setFormData({ ...formData, bank_name: e.target.value })}
              className={`w-full ${reqBorder(isFilled(formData.bank_name))}`}
              required
            >
              <option value="">Select Bank</option>
              {NAMIBIAN_BANKS.map(bank => (
                <option key={bank} value={bank}>{bank}</option>
              ))}
            </select>
          )}
          {!readOnly && formErrors.bank_name && <p className="text-rose-500 text-xs mt-1">{formErrors.bank_name}</p>}
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-800 dark:text-slate-200 mb-1">Branch Code</label>
          <input
            type="text"
            value={formData.branch_code || ''}
            readOnly={readOnly}
            onFocus={() => handleFieldFocus('branch_code')}
            onChange={e => !readOnly && setFormData({ ...formData, branch_code: e.target.value })}
            placeholder="Branch Code"
            className={reqFieldCls(readOnly, isFilled(formData.branch_code))}
            required
          />
          {!readOnly && formErrors.branch_code && <p className="text-rose-500 text-xs mt-1">{formErrors.branch_code}</p>}
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-800 dark:text-slate-200 mb-1">Account Number</label>
          <input
            type="text"
            value={formData.account_number || ''}
            readOnly={readOnly}
            onFocus={() => handleFieldFocus('account_number')}
            onChange={e => !readOnly && setFormData({ ...formData, account_number: e.target.value })}
            placeholder="Account Number"
            className={reqFieldCls(readOnly, isFilled(formData.account_number))}
            required
          />
          {!readOnly && formErrors.account_number && <p className="text-rose-500 text-xs mt-1">{formErrors.account_number}</p>}
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-800 dark:text-slate-200 mb-1">Account Type</label>
          <select
            value={formData.account_type || ''}
            disabled={readOnly}
            onFocus={() => handleFieldFocus('account_type')}
            onChange={e => !readOnly && setFormData({ ...formData, account_type: e.target.value })}
            className={reqFieldCls(readOnly, isFilled(formData.account_type))}
            required
          >
            <option value="">Select Account Type</option>
            {ACCOUNT_TYPES.map(type => (
              <option key={type} value={type}>{type}</option>
            ))}
          </select>
          {!readOnly && formErrors.account_type && <p className="text-rose-500 text-xs mt-1">{formErrors.account_type}</p>}
        </div>
      </div>
    </div>
  );
};

export default BankInfoForm;